import axios from 'axios';
import { API_BASE_URL } from '../creds';

const NewsModelHook = {
  // Save or update news
  saveNews: async (formData, editing) => {
    const url = editing ? `${API_BASE_URL}/news/${editing.id}` : `${API_BASE_URL}/news`;
    const method = editing ? 'put' : 'post';

    try {
      const response = await axios({
        method,
        url,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data', // Required for file uploads
        },
      });
      return response.data;
    } catch (error) {
      console.error('Save news error:', error.response?.data || error.message);
      throw new Error(`Failed to save news: ${error.response?.data?.detail || error.message}`);
    }
  },

  // Delete a single news item by ID
  deleteNews: async (id) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/news/${id}`);
      return response.data;
    } catch (error) {
      console.error('Delete news error:', error.response?.data || error.message);
      throw new Error(`Failed to delete news: ${error.response?.data?.detail || error.message}`);
    }
  },

  // Bulk delete news items (uses POST instead of DELETE for body support)
  bulkDeleteNews: async (intIds) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/news/bulk-delete`, {
        ids: intIds,
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Bulk delete news error:', error.response?.data || error.message);
      throw new Error(`Failed to bulk delete news: ${error.response?.data?.detail || error.message}`);
    }
  },
};

export default NewsModelHook;
